import { Link } from 'react-router-dom';

const SOCIAL_LINKS = [
  { icon: 'ri-github-fill', href: 'https://github.com/guilherme-marostica-dev', label: 'GitHub', handle: '@developer' },
  { icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/in/guilhermesmarostica/', label: 'LinkedIn', handle: 'in/developer' },
  { icon: 'ri-code-s-slash-line', href: 'https://dev.to/gmarostica_dev', label: 'Dev.to', handle: '@developer' },
];

const FOOTER_LINKS = [
  {
    title: 'Navigation',
    links: [
      { label: 'Home', href: '/' },
      { label: 'Projects', href: '/projects' },
      { label: 'Contact', href: '/#contact' },
    ],
  },
  {
    title: 'Work',
    links: [
      { label: 'Web Development', href: '/projects' },
      { label: 'AI & Machine Learning', href: '/projects' },
      { label: 'Open Source', href: 'https://github.com' },
      { label: 'Freelance', href: '/#contact' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Download CV', href: '/resume_2026.pdf' },
      { label: 'GitHub Profile', href: 'https://github.com' },
      { label: 'LinkedIn', href: 'https://linkedin.com' },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-emerald-950 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-8">
        {/* Top Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-mono font-bold text-2xl tracking-tight">
                &lt;<span className="text-emerald-400">dev</span>/&gt;
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Building high-performance software and developer tools that make a difference.
            </p>
            <div className="flex gap-2">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/10 text-gray-400 hover:text-white hover:border-emerald-400 hover:bg-emerald-400/10 transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {FOOTER_LINKS.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5">
                <a id={`footer-${col.title.toLowerCase()}`}>{col.title}</a>
              </h4>
              <ul className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('http') ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-gray-500 text-xs">
            &copy; {year} Developer Portfolio. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-gray-600 text-xs">Built with React + TypeScript</span>
            <span className="text-gray-700">·</span>
            <a href="/#contact" className="text-gray-500 text-xs hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}